import { useField } from "formik";

import { TextArea, TextAreaProps } from "./Textarea";
import {
  InputWrapperProps,
  InputWrapper,
} from "../../../components/inputs/_assets/input-wrapper/InputWrapper";

interface Props extends TextAreaProps, InputWrapperProps {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID?: string;
}

/**
 * @deprecated see TextAreaFormikField
 */
export function TextareaField({
  name,
  span = "auto",
  testID = "text-area-field",
  ...props
}: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <TextArea
        validationState={meta.touched && meta.error ? "invalid" : "valid"}
        errors={meta.touched && meta.error}
        {...field}
        {...props}
        onChange={helpers.setValue}
        testID={testID}
      />
    </InputWrapper>
  );
}
